<template>
    <UIcon name="i-bi-justify" size="40" class="mr-4 cursor-pointer text-blue-600 hover:text-blue-500 lg:hidden" @click="toggleNavigation" />

    <USlideover side="left" :overlay="true" v-model="isShowingNavigation">
        <UCard
            class="flex flex-1 flex-col"
            :ui="{
                background: 'bg-white dark:bg-gray-800',
                divide: 'divide-y divide-gray-100 dark:divide-gray-800',
                ring: '',
                body: { base: 'flex-1' },
                header: {
                    background: 'py-[29px] shadow-md bg-blue-600 dark:bg-gray-900'
                }
            }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-xl font-bold leading-6 text-white">Navigation</h3>

                    <UButton color="white" variant="outline" size="sm" icon="i-bi-x" class="-my-1 text-white" @click="toggleNavigation" />
                </div>
            </template>

            <UNavigationTree :links="navBarMobileLinks" :default-open="!defaultOpen" :multiple="false" />

            <UDivider class="my-4" />

            <div class="flex gap-x-3">
                <PagesSocialMedia size="lg" color="info" class="text-info-600" hover="text-info-500" />
            </div>
        </UCard>
    </USlideover>
</template>

<script setup>
    const isShowingNavigation = ref(false)
    const defaultOpen = ref(false)

    const toggleNavigation = () => {
        isShowingNavigation.value = !isShowingNavigation.value
    }

    const { toggleLogin } = inject('login')

    const clientPortal = () => {
        toggleNavigation()
        toggleLogin()
    }

    const navBarMobileLinks = [
        {
            label: 'Home',
            to: '/',
            icon: 'i-bi-house',
            click: () => toggleNavigation()
        },
        {
            label: 'Plantations',
            icon: 'i-ph-plant',
            children: [
                {
                    label: 'Agarwood Plantations',
                    to: '/plantations/agarwood-plantations',
                    icon: 'i-ph-plant',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Plantation Challenges',
                    to: '/plantations/plantation-challenges',
                    icon: 'i-ph-potted-plant',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Professional Management',
                    to: '/plantations/professional-management',
                    icon: 'i-bi-people',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Carbon Neutral Agriculture',
                    to: '/plantations/carbon-neutral-agriculture',
                    icon: 'i-mdi-periodic-table-carbon-dioxide',
                    click: () => toggleNavigation()
                }
            ]
        },
        {
            label: 'Sustainability',
            icon: 'i-carbon-sustainability',
            children: [
                {
                    label: 'Agriculture Asset Class',
                    to: '/sustainability/agriculture-asset-class',
                    icon: 'i-bi-graph-up-arrow',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Regenerative Practices',
                    to: '/sustainability/regenerative-practices',
                    icon: 'i-mdi-regenerative-agriculture',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Sustainable Future',
                    to: '/sustainability/sustainable-future',
                    icon: 'i-game-icons-stump-regrowth',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Global Warming Initiative',
                    to: '/sustainability/global-warming-initiative',
                    icon: 'i-bi-sun',
                    click: () => toggleNavigation()
                }
            ]
        },
        {
            label: 'Opportunities',
            icon: 'i-bi-graph-up-arrow',
            children: [
                {
                    label: 'Plantation Ownership',
                    to: '/opportunities/plantation-ownership',
                    icon: 'i-lucide-trees',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Agarwood Oil & Chips',
                    to: '/opportunities/agarwood-oil-and-chips',
                    icon: 'i-carbon-soil-moisture-field',
                    click: () => toggleNavigation()
                }
            ]
        },
        {
            label: 'Associates',
            icon: 'i-bi-people',
            children: [
                {
                    label: 'Al Hashimi',
                    to: '/associates/al-hashimi',
                    icon: 'i-hugeicons-perfume',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Ghallia',
                    to: '/associates/ghallia',
                    icon: 'i-cbi-essential-oil-diffuser-alt',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Ouddict Artisanal Oud Community',
                    to: '/associates/ouddict-artisanal-oud-community',
                    icon: 'i-bi-chat-dots',
                    click: () => toggleNavigation()
                }
            ]
        },
        {
            label: 'Corporate',
            icon: 'i-ion-business-outline',
            children: [
                {
                    label: 'Book a Discovery Call',
                    to: '/corporate/book-a-discovery-call',
                    icon: 'i-bi-telephone',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Core Values',
                    to: '/corporate/core-values',
                    icon: 'i-bi-award',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Meet the Team',
                    to: '/corporate/meet-the-team',
                    icon: 'i-bi-people',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Careers',
                    to: '/corporate/careers',
                    icon: 'i-bi-person-plus',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Investor Relations',
                    to: '/corporate/investor-relations',
                    icon: 'i-carbon-chart-relationship',
                    click: () => toggleNavigation()
                },
                {
                    label: 'Contact Us',
                    to: '/corporate/contact-us',
                    icon: 'i-bi-pin-map',
                    click: () => toggleNavigation()
                }
            ]
        },
        {
            label: 'Claim Your FREE Guide',
            icon: 'i-bi-file-pdf',
            to: '/agarwood-plantation-ownership',
            click: () => toggleNavigation()
        },
        {
            label: 'Client Portal',
            icon: 'i-bi-person-lock',
            click: () => clientPortal()
        }
    ]
</script>
